import styled from '@emotion/styled';
import Button from '../../atoms/buttons/Button';
import colors from '../../theme/colors';
import { FONT_FAMILIES } from '../../theme/material/constants';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const DefaultButton = styled(Button)(() => ({
  background: colors.gray['100'],
  border: `1px solid ${colors.gray['1200']}`,
  borderRadius: '4px',
  fontSize: '14px !important',
  fontWeight: 400,
  fontFamily: FONT_FAMILIES.primary,
  letterSpacing: '-0.28px',
  width: '100%',
  height: 40,
  color: colors.light.gray.light,
}));

export interface GoogleButtonContainerProps {
  isGoogleScriptLoaded: boolean;
}

export const GoogleButtonContainer = styled('div')<GoogleButtonContainerProps>(
  {
    width: '100%',
    minHeight: 40,
    transition: 'opacity 1s linear',
  },
  ({ isGoogleScriptLoaded }) => {
    return {
      display: `${isGoogleScriptLoaded ? 'block' : 'none'}`,
    };
  }
);
